"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsOrderField = exports.MetricName = exports.CreatedFromValues = exports.EditableWidgetTrackingPluginId = exports.IndicatorCampaignStatusRisk = exports.IndicatorCategory = exports.IndicatorId = exports.MetricType = void 0;
var MetricType;
(function (MetricType) {
    MetricType["Transaction"] = "transaction";
    MetricType["PageView"] = "page_view";
    MetricType["ActionTracking"] = "action_tracking";
    MetricType["CustomTracking"] = "custom_tracking";
    MetricType["BrowsingIndicator"] = "indicator";
    MetricType["WidgetTracking"] = "widget_tracking";
})(MetricType = exports.MetricType || (exports.MetricType = {}));
var IndicatorId;
(function (IndicatorId) {
    IndicatorId[IndicatorId["BounceRate"] = 1] = "BounceRate";
    IndicatorId[IndicatorId["NumberOfViewedPages"] = 2] = "NumberOfViewedPages";
    IndicatorId[IndicatorId["RevisitRate"] = 3] = "RevisitRate";
})(IndicatorId = exports.IndicatorId || (exports.IndicatorId = {}));
var IndicatorCategory;
(function (IndicatorCategory) {
    IndicatorCategory["BounceRate"] = "bounce_rate";
    IndicatorCategory["RevisitRate"] = "revisit_rate";
    IndicatorCategory["PagesViewed"] = "pages_viewed";
    IndicatorCategory["ExitRate"] = "exit_rate";
})(IndicatorCategory = exports.IndicatorCategory || (exports.IndicatorCategory = {}));
var IndicatorCampaignStatusRisk;
(function (IndicatorCampaignStatusRisk) {
    IndicatorCampaignStatusRisk["High"] = "high";
    IndicatorCampaignStatusRisk["Medium"] = "medium";
    IndicatorCampaignStatusRisk["Low"] = "low";
})(IndicatorCampaignStatusRisk = exports.IndicatorCampaignStatusRisk || (exports.IndicatorCampaignStatusRisk = {}));
var EditableWidgetTrackingPluginId;
(function (EditableWidgetTrackingPluginId) {
    EditableWidgetTrackingPluginId["DwellTimeWidgetTracking"] = "c8fd96cb-5de9-44b1-b394-43f7786413d4";
    EditableWidgetTrackingPluginId["ScrollRateWidgetTracking"] = "178fe528-8964-4138-af48-ce87c65b8f58";
    EditableWidgetTrackingPluginId["ElementVisibleWidgetTracking"] = "a699b9a9-036a-485c-86e3-040751f53fac";
    EditableWidgetTrackingPluginId["IframeClickTracking"] = "8194d170-e5f4-4788-bded-f043a7385915";
})(EditableWidgetTrackingPluginId = exports.EditableWidgetTrackingPluginId || (exports.EditableWidgetTrackingPluginId = {}));
var CreatedFromValues;
(function (CreatedFromValues) {
    CreatedFromValues["CUSTOM_CODE"] = "custom_code";
    CreatedFromValues["DATALAYER"] = "datalayer";
    CreatedFromValues["SHOPIFY"] = "shopify";
})(CreatedFromValues = exports.CreatedFromValues || (exports.CreatedFromValues = {}));
var MetricName;
(function (MetricName) {
    MetricName["Transaction"] = "transactions";
    MetricName["ActionTracking"] = "action_trackings";
    MetricName["WidgetTracking"] = "widget_trackings";
    MetricName["CustomTracking"] = "custom_trackings";
    MetricName["PageView"] = "page_views";
})(MetricName = exports.MetricName || (exports.MetricName = {}));
var MetricsOrderField;
(function (MetricsOrderField) {
    MetricsOrderField["AccountLevel"] = "account_level";
})(MetricsOrderField = exports.MetricsOrderField || (exports.MetricsOrderField = {}));
//# sourceMappingURL=types.js.map